export default __webpack_public_path__ + "static/media/ico-apple.0aaac925.svg";